// extracted by mini-css-extract-plugin
export var boxItems = "_8a-1";
export var button = "_8a-5";
export var filterGroupBox = "_8a-0";
export var icon = "_8a-2";
export var iconSecondary = "_8a-4";
export var iconWrapper = "_8a-3";